import classNames from 'classnames';
import React from 'react';

export type InvalidMediaSetProps = {
  className: string;
};
export const InvalidMediaSet = ({ className }: InvalidMediaSetProps): JSX.Element => {
  return (
    <div className={classNames('grid-x', 'align-middle', 'align-center', className)}>
      <p>Unable to generate preview. The current media set is invalid.</p>
    </div>
  );
};
